import React,{useEffect,useState} from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import EventForm from './EventForm';
import {formatDate} from '../../utils/formatDate';
import {eventService} from '../../services/eventService';

const {FiPlus,FiEdit2,FiPower,FiCalendar,FiMapPin,FiClock}=FiIcons;

const TYPE_LABELS={
  examen: 'Examen',
  torneo: 'Torneo',
  convivio: 'Convivio',
  'clase-especial': 'Clase especial',
};

export default function EventManagement({user}) {
  const [events,setEvents]=useState([]);
  const [editing,setEditing]=useState(null);
  const [isFormOpen,setIsFormOpen]=useState(false);

  useEffect(()=>{
    eventService.getEvents().then(setEvents).catch(error=> alert(error.message));
  },[]);

  const save=async (event)=>{
    try {
      setEvents(await eventService.saveEvent(event));
      setIsFormOpen(false);
      setEditing(null);
    } catch (error) {
      alert(error.message);
    }
  };

  const toggle=async (id)=>{
    try {
      setEvents(await eventService.toggleStatus(id));
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 pb-20">
      <div className="flex flex-col md:flex-row justify-between gap-6 mb-12">
        <div>
          <span className="text-red-500 font-black tracking-[.4em] uppercase text-[10px]">
            Administración
          </span>

          <h1 className="text-5xl font-black uppercase tracking-tighter text-white mt-3">
            Eventos del Dojang
          </h1>
        </div>

        <button
          onClick={()=> {setEditing(null);setIsFormOpen(true);}}
          className="bg-red-600 hover:bg-red-500 text-white px-7 py-4 rounded-2xl font-black uppercase tracking-widest text-[10px] flex items-center gap-3 h-fit"
        >
          <SafeIcon icon={FiPlus} />
          Nuevo evento
        </button>
      </div>

      <div className="grid gap-4">
        {events
          .sort((a,b)=> a.eventDate.localeCompare(b.eventDate))
          .map(event=> (
            <motion.div
              layout
              key={event.id}
              className="glass-card-light rounded-3xl p-6 flex flex-col lg:flex-row gap-6 lg:items-center justify-between"
            >
              {event.image && (
                <img
                  src={event.image}
                  alt={event.title}
                  className="h-28 w-full lg:w-40 rounded-2xl object-cover border border-white/10"
                />
              )}

              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-3 mb-2">
                  <span className={`text-[9px] font-black uppercase tracking-widest px-3 py-1 rounded-full ${
                    event.status
                      ? 'bg-green-500/20 text-green-400'
                      : 'bg-zinc-700 text-zinc-400'
                  }`}>
                    {event.status ? 'Activo' : 'Inactivo'}
                  </span>

                  <span className="text-red-400 text-[9px] font-black uppercase tracking-widest">
                    {TYPE_LABELS[event.type]}
                  </span>
                </div>

                <h2 className="text-xl font-black uppercase text-white">
                  {event.title}
                </h2>

                <p className="text-white/60 text-sm mt-2 line-clamp-2 whitespace-pre-line">
                  {event.description}
                </p>
              </div>

              <div className="grid sm:grid-cols-3 gap-4 text-[10px] font-bold uppercase tracking-wider text-zinc-300">
                <span className="flex items-center gap-2">
                  <SafeIcon icon={FiCalendar} className="text-red-500" />
                  {formatDate(event.eventDate)}
                </span>

                <span className="flex items-center gap-2">
                  <SafeIcon icon={FiClock} className="text-red-500" />
                  {event.time}
                </span>

                <span className="flex items-center gap-2">
                  <SafeIcon icon={FiMapPin} className="text-red-500" />
                  {event.place}
                </span>
              </div>

              <div className="flex gap-2">
                <button
                  onClick={()=> {setEditing(event);setIsFormOpen(true);}}
                  className="p-3 rounded-xl bg-white/5 hover:bg-white/10 text-white"
                >
                  <SafeIcon icon={FiEdit2} />
                </button>

                <button
                  onClick={()=> toggle(event.id)}
                  className={`p-3 rounded-xl text-white ${
                    event.status
                      ? 'bg-green-600/30 hover:bg-zinc-700'
                      : 'bg-zinc-700 hover:bg-green-600'
                  }`}
                >
                  <SafeIcon icon={FiPower} />
                </button>
              </div>
            </motion.div>
          ))}
      </div>

      {isFormOpen && (
        <EventForm
          event={editing}
          user={user}
          onClose={()=> setIsFormOpen(false)}
          onSave={save}
        />
      )}
    </div>
  );
}